// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__PY9Zy","buttons":"RemoveExpirationActionButtons_buttons__9r-BR"};